export class ReweighConstants {
  static readonly DEFAULT_PAGE_TITLE_PREFIX = 'XPO LTL Edge Reweigh';
}
